import { format, parseISO } from "date-fns";
import { ms } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const DatePick = ({ value, onChange, placeholder, testid }) => (
  <div className="inline-flex items-center gap-1">
    <Popover>
      <PopoverTrigger asChild>
        <button data-testid={testid}
          className="h-11 px-3 rounded-xl bg-surface border border-line text-sm inline-flex items-center gap-2 min-w-[150px] hover:border-[var(--mute)]">
          <CalendarDays size={15} className="text-mute" />
          <span className={value ? "text-ink" : "text-mute"}>{value ? format(parseISO(value), "d MMM yyyy", { locale: ms }) : placeholder}</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={ms} selected={value ? parseISO(value) : undefined}
          onSelect={(d) => onChange(d ? format(d, "yyyy-MM-dd") : "")} initialFocus />
      </PopoverContent>
    </Popover>
    {value && <button onClick={() => onChange("")} aria-label="Kosongkan tarikh" data-testid={`${testid}-clear`} className="h-8 w-8 grid place-items-center text-mute hover:text-ink"><X size={14} /></button>}
  </div>
);
